
export const fetchBnbPrice = async () => {
  const bnbPriceApi = 'https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd'
  return await fetch(bnbPriceApi)
}